// extracted by mini-css-extract-plugin
var _1 = "kZ1UE";
var _2 = "Qx2e9";
export { _1 as "form", _2 as "orSeparator" }
